import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getImageData } from '@utilities';
import { usePageData, PageContextProps } from '@context';

/**
 * Simple Banner.
 */
const SimpleBanner: React.FC<{
  bannerTitle: string;
  bannerSubTitle: string;
  bannerAltTag?: string;
  storybookImage?: string;
}> = ({ bannerTitle, bannerSubTitle, bannerAltTag, storybookImage }) => {
  const { pageData }: PageContextProps = usePageData();
  if (!pageData) return null;

  const safeImage = getImageData('simple_banner_image', pageData);

  /**
   * Render.
   */
  if (safeImage) {
    return (
      <section className={`banner-wrapper simple-banner`}>
        <div className="img-container">
          {storybookImage && storybookImage !== '' ? (
            <div className="gatsby-image-wrapper">
              <img
                src={storybookImage}
                alt={bannerAltTag ?? bannerTitle}
                className="storybook-img"
              />
            </div>
          ) : (
            <GatsbyImage image={safeImage} alt={bannerAltTag ?? bannerTitle} />
          )}
        </div>
        <div className="container simple-banner-container">
          <div className="banner-content">
            <h2>{bannerTitle}</h2>
            {bannerSubTitle && <h3>{bannerSubTitle}</h3>}
          </div>
        </div>
      </section>
    );
  }
  return null;
};
export default SimpleBanner;
